import UtilityDrawerBody from 'components/drawers/utility-drawer/utility-drawer-body/utility-drawer-body.component';
import UtilityDrawer from 'components/drawers/utility-drawer/utility-drawer.component';
import { useTranslation } from 'react-i18next';
import GroupsFullDetailsButton from './groups-full-details-button/groups-full-details-button.component';
import GroupsInfoCard from './groups-info-card/groups-info-card.component';
import GroupsDetailsDrawerLocationsList from './groups-details-drawer-locations-list/groups-details-drawer-locations-list.component';
import GroupsDisplayContent from './groups-display-content/groups-display-content.component';

const GroupsDetailsDrawer = ({ open, close, drawerData }) => {
  const { t } = useTranslation();
  const { groupId } = drawerData || {};

  return (
    <UtilityDrawer
      open={open}
      onClose={close}
      isLoading={false}
      data-testid="GroupsDetails.Drawer"
      title={t('drawer.groupsDetailsDrawer.title')}
    >
      <UtilityDrawerBody>
        <GroupsFullDetailsButton close={close} groupId={groupId} />
        <GroupsInfoCard drawerData={drawerData} />
        {drawerData?.storeInfos?.length > 0 && (
          <GroupsDetailsDrawerLocationsList stores={drawerData?.storeInfos} />
        )}
        <GroupsDisplayContent displayInfos={drawerData?.displayInfo} />
      </UtilityDrawerBody>
    </UtilityDrawer>
  );
};

export default GroupsDetailsDrawer;
